<template>
  <div class="theme_gradient">
    <!-- <LoadingOverlay v-if="isLoading" /> -->
    <div>
      <GenericFilter
      :basicFilterlength="getFilterSchema.basicFilterLength"
      :filterSchema="getFilterSchema.schema"
      :selectedFilters="selectedFilters"
      :filterDependencyObj="filterDependencyObj"
      :isFetchingFilter="isFetchingGenericFilter"
      :callback="updateRouterURL"
      :searchCallback="searchCallback"
      :filterAction="filterAction"
      :backURL="backURL" />
      <Pagination
        :total="getJobCount"
        :perPage="10"
        @pagechanged="pagechanged"
        :maxVisibleButtons="isMobile ? 3 : 3"
        :position="isMobile ? 'left' : 'end'"
      />
      <div class="job-board">
        <div v-if="isMobile && jobAdvertisement == true">
          <advertisement :allign="'horizontal'"></advertisement>
        </div>

        <div class="d-flex flex-row">
          <div
            class="d-flex flex-row w-100"
            v-if="
              !isFetchingGenericFilter &&
              !isJobBoardFetching &&
              !getJobBoard.length
            ">
            <div class="d-flex flex-column" style="margin-right: 20%">
              <h5 v-if="getJobCount" class="count">
                Total Jobs: {{ getJobCount }}
              </h5>
              <h5 class="count">Search Results: {{ getFilterCount }}</h5>
            </div>

            <div class="d-flex flex-column mt-5">
              <h4>
                No jobs matched the selected criteria
                <span v-if="AddJobRoles.includes(currentUserRole)"
                  >, Please add a Job</span
                >
              </h4>
              <CButton
                v-if="AddJobRoles.includes(currentUserRole)"
                @click="navigateToAddJob()"
                class="btn-primary"
                title="Add Job"
                >Add Job</CButton
              >
            </div>
          </div>

          <div
            id="job-board-body"
            class="job-board-list col-md-4" v-if="getFilterCount||isJobBoardFetching">
            <div>
              <h6 v-if="getJobCount" class="count">
                Total Jobs: {{ getJobCount }}<span class="pl-3"></span> Search
                Results: {{ getFilterCount }}
              </h6>
            </div>
            <job-card
              :key="index"
              :index="index"
              v-for="(job, index) in getJobBoard"
              :item="job"
              :class="
                !isMobile &&
                getSelectedJobBoard &&
                getSelectedJobBoard.job_id == job.job_id
                  ? 'highlight'
                  : 'disabled'
              "
              @click.native="jobCardSelectedCallback(job)"></job-card>
            <div v-if="noMoreDataFromJobBoard" class="no-more-data">
              <p v-if="getJobBoard.length > 0" class="btn-primary">
                No More Data!
              </p>
            </div>
            <div
              v-if="!noMoreDataFromJobBoard"
              class="d-flex justify-content-around align-items-center has-loading-overlay"
              style="height: 200px">
              <div v-if="isJobBoardFetching" class="skeleton-card"></div>
              <!-- <LoadingOverlay v-if="isJobBoardFetching" /> -->
            </div>
          </div>
          <div
            class="job-board-detail col-md-6"
            :class="jobAdvertisement == false ? 'col-md-8' : 'col-md-6'"
            v-if="getJobBoard.length > 0 || isJobBoardFetching">
            <CModal
              id="applyjobModal"
              title="Apply Job"
              color="primary"
              centered:false
              @update:show="onShow"
              :show.sync="successModal"
              >{{ displayMessage }}</CModal
            >
            <div
              class="skeleton-card"
              v-if="!(getSelectedJobBoard && getSelectedJobBoard.job_id)"></div>
            <job-detail
              v-else
              ref="detail"
              :getSelectedJobBoard="getSelectedJobBoard"
              @hook:mounted="detail = $refs.detail"
              @hook:beforeDestroy="detail = null">
            </job-detail>
          </div>
          <div
            v-if="isMobile != true && jobAdvertisement == true"
            class="col-lg-2"
            style="padding-right: 0px">
            <advertisement :allign="'verticle'"/>
          </div>
        </div>
      </div>
    </div>
    </div>
</template>

<script>
import JobBoardMixin from "../mixins/JobBoardMixin";

const FROM_OPPORTUNITIES_KEY = "jobBoardFromOpportunities";

export default {
  mixins: [JobBoardMixin],
  data() {
    // Mobile opens the job detail page and comes back via a plain /public/job-board push, and
    // filtering rewrites the query too, so the flag is kept in sessionStorage, not read live.
    if (this.$route.query.from === "opportunities") {
      sessionStorage.setItem(FROM_OPPORTUNITIES_KEY, "1");
    }
    return { cameFromOpportunities: !!sessionStorage.getItem(FROM_OPPORTUNITIES_KEY) };
  },
  computed: {
    backURL() {
      return this.cameFromOpportunities
        ? "/react/dashboard/opportunities"
        : JobBoardMixin.computed.backURL.call(this);
    },
  },
  beforeRouteLeave(to, from, next) {
    // Keep it only while moving into a job's detail page; anywhere else ends the session of this flow.
    if (!to.path.includes("job-board-detail")) sessionStorage.removeItem(FROM_OPPORTUNITIES_KEY);
    next();
  },
}
</script>

